import { NgReduxRouterModule } from "@angular-redux/router";
import { HashLocationStrategy, LocationStrategy } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { AppComponent } from "./app.component";
import { appRoutingProviders, routing } from "./app.routing";

import { ApolloBootstrapModule } from "./shared/graphql/client.bootstrap";

import { JwtModule } from "@auth0/angular-jwt";
import { CookieModule } from "ngx-cookie";
import { StoreModule } from "./shared/redux/store.module";

const locationStrategyProvider = {
    provide: LocationStrategy,
    useClass: HashLocationStrategy,
};

export function tokenGetter(): string | Promise<string> {
    return localStorage.getItem("isp-app.token") as string;
}

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        routing,
        BrowserAnimationsModule,
        CookieModule.forRoot(),
        HttpClientModule,
        JwtModule.forRoot({
            config: {
                tokenGetter,
            },
        }),
        StoreModule,
        NgReduxRouterModule.forRoot(),
        ApolloBootstrapModule,
    ],
    providers: [
        appRoutingProviders,
        locationStrategyProvider,
    ],
    bootstrap: [AppComponent],
})
export class AppModule {
}
